document.addEventListener('DOMContentLoaded', () => {
  // obecne
  let bodyWidth = window.innerWidth;

  initAccessibilityTranslations();

  // události při resize okna
  window.addEventListener('resize', function () {
    // osetreni, zda se velikost zmenila
    if (bodyWidth !== window.innerWidth) {
      // nastavíme novou šířku
      bodyWidth = window.innerWidth;
      // zresetuj menu
      resetMenu();
      // check navigation overflow
      if (document.querySelector('.nav:not(.nav--2)')) {
        checkNavOverflow();
      }
      if (document.querySelector('.nav--2')) {
        checkNavGridBreak();
      }
    }
  });
  // mobilní menu
  function switchMenu() {
    // označíme zda je menu zavřeno či nikoliv
    if (document.querySelector('.nav-switcher').classList.contains('is-open')) {
      document.querySelector('.nav-switcher').classList.remove('is-open');
      document.querySelector('.nav').classList.remove('is-open');
      document.querySelector('.header__blur').classList.remove('is-active');
      document.body.classList.remove('is-unscrollable');
    } else {
      document.querySelector('.nav-switcher').classList.add('is-open');
      document.querySelector('.nav').classList.add('is-open');
      document.querySelector('.header__blur').classList.add('is-active');
      document.body.classList.add('is-unscrollable');
    }
  }
  // při změně rozlišení resetujeme menu
  function resetMenu() {
    document.querySelector('.nav-switcher').classList.remove('is-open');
    document.querySelector('.nav').classList.remove('is-open');
    document.querySelector('.header__blur').classList.remove('is-active');
    //document.querySelector('.search-widget').classList.remove('is-open');
    const searchWidget = document.querySelector('.search-widget');
    if (searchWidget) {
      searchWidget.classList.remove('is-open');
    }
    document.querySelectorAll('.nav__link-wrap').forEach(function (element) {
      element.classList.remove('is-open');
      element.blur();
    });
    if (document.querySelector('.js-lang-toggle')) {
      document.querySelector('.js-lang-toggle').classList.remove('is-active');
    }
    document.body.classList.remove('is-unscrollable');
    if (document.querySelector('.search')) {
      document.querySelectorAll('.search').forEach(function (element) {
        element.classList.remove('is-active');
      });
    }
    if (document.querySelector('.share')) {
      document.querySelectorAll('.share').forEach(function (element) {
        element.classList.remove('is-open');
      });
    }
    // zresetuj custom select
    closeAllSelect();
  }

  Array.from(document.getElementsByClassName('js-nav-link-dropdown')).forEach((element) => {
    element.addEventListener('click', function (event) {
      event.stopPropagation();
      event.preventDefault();
      if (this.closest('.nav__link-wrap').classList.contains('is-open')) {
        document.querySelectorAll('.nav__link-wrap').forEach((wrap) => {
          wrap.classList.remove('is-open');
        });
      } else {
        document.querySelectorAll('.nav__link-wrap').forEach((wrap) => {
          wrap.classList.remove('is-open');
        });
        this.closest('.nav__link-wrap').classList.add('is-open');
      }
    });

    element.addEventListener('mouseenter', function (event) {
      event.preventDefault();
      if (window.matchMedia('(min-width: 64rem)').matches) {
        resetMenu();
      }
    });
  });

  Array.from(document.getElementsByClassName('nav__submenu-title')).forEach((element) => {
    element.addEventListener('click', function (event) {
      event.preventDefault();
      this.closest('.nav__link-wrap').classList.remove('is-open');
      document.querySelectorAll('.js-lang-toggle').forEach((wrap) => {
        wrap.classList.remove('is-active');
      });
    });
  });

  // search toggle
  if (document.querySelector('.js-search-toggle')) {
    document.querySelectorAll('.js-search-toggle').forEach((element) => {
      element.addEventListener('click', function () {
        if (document.querySelector('.search-widget').classList.contains('is-open')) {
          document.querySelector('.search-widget').classList.remove('is-open');
          document.querySelector('.header__blur').classList.remove('is-active');
          document.body.classList.remove('is-unscrollable');
        } else {
          resetMenu();
          document.querySelector('.search-widget').classList.add('is-open');
          document.querySelector('.header__blur').classList.add('is-active');
          document.body.classList.add('is-unscrollable');
        }
      });
    });
  }

  // zobrazení našeptáveče (pouze demo účely)
  if (document.querySelector('.js-search-whisper')) {
    const searchInputs = document.querySelectorAll('.js-search-whisper');

    searchInputs.forEach((searchInput) => {
      function showSearchWhisper() {
        const searchWhisper = searchInput.closest('.search');
        // Check if the input has at least one character
        if (searchInput.value.length > 0) {
          // Add the 'is-active' class if input is not empty
          searchWhisper.classList.add('is-active');
        } else {
          // Remove the 'is-active' class if input is empty
          searchWhisper.classList.remove('is-active');
        }
      }
      // Add event listener to each search input
      searchInput.addEventListener('input', showSearchWhisper);
    });
  }

  // výběr jazyk lang toggle
  if (document.querySelector('.js-lang-toggle')) {
    document.querySelectorAll('.js-lang-toggle').forEach((element) => {
      element.addEventListener('click', function (event) {
        event.preventDefault();
        if (document.querySelector('.nav__link-wrap--lang').classList.contains('is-open')) {
          document.querySelector('.nav__link-wrap--lang').classList.remove('is-open');
          document.querySelector('.header__blur').classList.remove('is-active');
          document.body.classList.remove('is-unscrollable');
          element.classList.remove('is-active');
        } else {
          //resetMenu();
          document.querySelectorAll('.nav__link-wrap').forEach((wrap) => {
            wrap.classList.remove('is-open');
          });
          document.querySelector('.nav__link-wrap--lang').classList.add('is-open');
          document.querySelector('.header__blur').classList.add('is-active');
          document.body.classList.add('is-unscrollable');
          element.classList.add('is-active');
          element.blur();
        }
      });
    });
  }

  const redirects = document.querySelectorAll('[data-redirect]');
  if (redirects) {
    redirects.forEach((redirec) => {
      redirec.addEventListener('click', function (event) {
        event.preventDefault();
        window.location.href = redirec.getAttribute('data-redirect');
      });
    });
  }

  // diskuze odpovědět
  if (document.querySelector('.reply-simple')) {
    document.querySelectorAll('.js-discuss-reply').forEach((element) => {
      element.addEventListener('click', function (event) {
        event.preventDefault();
        this.classList.add('is-hidden');
        let nextSibling = this.nextElementSibling;
        if (nextSibling && nextSibling.classList.contains('reply-simple')) {
          nextSibling.classList.add('is-open');
          var textarea = nextSibling.querySelector('textarea');
          if (textarea) {
            textarea.focus();
          }
        }
      });
    });
  }

  // diskuze odpovědět
  if (document.querySelector('.reply')) {
    let replyTextareas = document.querySelectorAll('.reply textarea');
    let replyButtons = document.querySelectorAll('.reply button');

    replyTextareas.forEach((textarea, index) => {
      let button = replyButtons[index];
      textarea.addEventListener('input', function () {
        if (textarea.value.trim() !== '') {
          button.removeAttribute('disabled');
        } else {
          button.setAttribute('disabled', 'disabled');
        }
      });
    });
  }

  // reset menu po kliknutí na main
  document.querySelector('main').addEventListener('click', function () {
    resetMenu();
  });

  document.querySelectorAll('.nav a').forEach((element) => {
    element.addEventListener('click', function () {
      resetMenu();
    });
  });

  // spouštěč
  document.querySelector('.nav-switcher').addEventListener('click', function () {
    switchMenu();
  });

  // Template 2 navigation
  if (document.querySelector('.nav.nav--2')) {
    function checkNavGridBreak() {
      const navWraps = [...document.querySelectorAll('.nav.nav--2 .js-nav__link-wrap')];
      const moreWrap = document.querySelector('.nav.nav--2 .js-nav__link-wrap--more');
      const moreGrid = moreWrap.querySelector('.nav__grid');

      // Reset
      navWraps.forEach((item) => item.classList.remove('is-hidden'));
      moreWrap.classList.add('is-hidden');
      moreGrid.innerHTML = ''; // Clear the more grid

      if (window.innerWidth >= 1024) {
        //const firstRowBottom = navWraps[0]?.getBoundingClientRect().bottom;
        const firstRowBottom = navWraps.length > 0 ? navWraps[0].getBoundingClientRect().bottom : undefined;

        let isBroken = false;
        const overflowedItems = [];
        let lastVisibleIndex = -1;

        for (let i = 0; i < navWraps.length; i++) {
          const wrapBottom = navWraps[i].getBoundingClientRect().bottom;
          if (wrapBottom > firstRowBottom) {
            isBroken = true;
            overflowedItems.push(navWraps[i]);
          } else {
            lastVisibleIndex = i;
          }
        }

        if (lastVisibleIndex >= 0 && !overflowedItems.includes(navWraps[lastVisibleIndex])) {
          overflowedItems.push(navWraps[lastVisibleIndex]);
        }

        if (isBroken) {
          moreWrap.classList.remove('is-hidden');

          overflowedItems.reverse().forEach((wrap) => {
            wrap.classList.add('is-hidden');

            // Přesun odkazů do More
            const links = wrap.querySelectorAll('a.nav__link');
            const batch = [...links].map((link) => link.cloneNode(true));

            batch.forEach((link) => moreGrid.appendChild(link));
          });
        }
      }
    }

    // Debounce function
    function debounce(func, wait = 100) {
      let timeout;
      return function (...args) {
        const context = this;
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(context, args), wait);
      };
    }

    // Run the checkNavGridBreak on page load and on resize
    const debouncedCheckNavGridBreak = debounce(checkNavGridBreak);
    window.addEventListener('resize', debouncedCheckNavGridBreak);
    window.addEventListener('easy-read-off', checkNavGridBreak);
    window.addEventListener('easy-read-on', checkNavGridBreak);
  }

  // navigation overflow
  if (document.querySelector('.nav:not(.nav--2)')) {
    let isRecalculating = false;

    function checkNavOverflow() {
      isRecalculating = true;
      const nav = document.querySelector('.nav');
      const navWraps = [...document.querySelectorAll('.js-nav__link-wrap')];
      const moreWrap = document.querySelector('.js-nav__link-wrap--more');
      const moreGrid = moreWrap.querySelector('.nav__grid');

      // Reset any changes
      navWraps.forEach((item) => item.classList.remove('is-hidden'));
      moreWrap.classList.add('is-hidden');
      moreGrid.innerHTML = ''; // Clear the more grid

      if (window.innerWidth >= 1024) {
        let isOverflowing = nav.scrollWidth > nav.clientWidth;

        if (isOverflowing) {
          // Show 'More' button
          moreWrap.classList.remove('is-hidden');

          let visibleCount = navWraps.length;

          for (let i = navWraps.length - 1; i >= 0; i--) {
            navWraps[i].classList.add('is-hidden');
            isOverflowing = nav.scrollWidth > nav.clientWidth;

            // Collect the links from the current navWrap
            const hiddenLinks = navWraps[i].querySelectorAll('a.nav__link');
            const batch = []; // Collect all links in this batch

            hiddenLinks.forEach((link) => {
              batch.push(link.cloneNode(true)); // Clone and store the links in the batch
            });

            // Prepend the batch of links all at once
            batch.reverse().forEach((link) => {
              moreGrid.prepend(link); // Add each link in the batch in reverse order to keep the correct sequence
            });

            // Count visible navWraps
            visibleCount = navWraps.filter((wrap) => !wrap.classList.contains('is-hidden')).length;
            if (visibleCount <= 2 || !isOverflowing) {
              break;
            }
          }
        }
      }
      isRecalculating = false;
    }

    // Debounce function to optimize resize performance
    function debounce(func, wait = 100) {
      let timeout;
      return function (...args) {
        const context = this;
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(context, args), wait);
      };
    }

    // Run the checkNavOverflow on page load and on window resize
    const debouncedCheckNavOverflow = debounce(checkNavOverflow);
    window.addEventListener('resize', debouncedCheckNavOverflow);

    // Recalculate nav overflow when font-size changes (e.g. easy-read mode)
    const firstNavLinkText = document.querySelector('.js-nav__link-wrap .nav__link-text');
    if (firstNavLinkText) {
      const navResizeObserver = new ResizeObserver(() => {
        if (isRecalculating) return;
        debouncedCheckNavOverflow();
      });
      navResizeObserver.observe(firstNavLinkText);
    }
  }

  // události při načtení stránky
  window.addEventListener('load', function () {
    // AOS fix pro první načítání
    // AOS.refresh();
    if (document.querySelector('.nav:not(.nav--2)')) {
      checkNavOverflow();
    }
    if (document.querySelector('.nav--2')) {
      checkNavGridBreak();
    }
  });

  // události při scroolování
  window.addEventListener('scroll', function () {
    //...
  });

  // modal okna
  if (document.querySelector('.modal')) {
    modal();
  }

  var newsletterForms = document.querySelectorAll(
    "[name='newsletter_form'], [name='newsletter_footer_form'], form[action*='newsletter-form']"
  );
  if (newsletterForms.length) {
    bindPostForms(newsletterForms);
  }

  if (document.querySelector("[name='contact_form']")) {
    bindPostForms(document.querySelectorAll("[name='contact_form']"));
  }

  // sdílení
  if (document.querySelector('.share')) {
    share();
  }

  // taby
  if (document.querySelector('.tab')) {
    if (document.querySelector('.events-page')) {
      tab(updateEventCalendarOnTabChange);
    } else {
      tab();
    }
  }
  // slider

  if (document.querySelector('.slider')) {
    const sliders = document.querySelectorAll('.slider');
    // glider
    [...sliders].forEach((sliderElement) => {
      if (sliderElement) {
        const isSlider2 = sliderElement.classList.contains('slider--2');
        const isSlider3 = sliderElement.classList.contains('slider--3');

        new Glider(sliderElement, {
          slidesToShow: isSlider3 ? 2 : 1.2,
          slidesToScroll: 1,
          draggable: true,
          dots: '.slider__dots',
          scrollLock: false,
          scrollLockDelay: 0,
          rewind: false,
          arrows: {
            prev: '.slider__btn-prev',
            next: '.slider__btn-next',
          },
          responsive: [
            {
              // screens greater than >= 576px
              breakpoint: 576,
              settings: {
                slidesToScroll: 1,
                slidesToShow: isSlider3 ? 3 : 2.3,
              },
            },
            {
              // screens greater than >= 768px
              breakpoint: 768,
              settings: {
                slidesToShow: isSlider3 ? 'auto' : 2.3,
                ...(typeof isSlider3 !== 'undefined' && isSlider3 ? { itemWidth: 252 } : {}),
                slidesToScroll: 1,
                scrollLock: true,
              },
            },
            {
              // screens greater than >= 1200px
              breakpoint: 1200,
              settings: {
                slidesToShow: 'auto',
                slidesToScroll: 1,
                itemWidth: isSlider3 ? 252 : isSlider2 ? 444 : 488,
                exactWidth: true,
              },
            },
          ],
        });
      }
    });
    //gliderAutoplay(slider, { interval: 6000 });
  }

  if (document.querySelector('.calendar-slider')) {
    new Glider(document.querySelector('.calendar-slider'), {
      slidesToShow: 1,
      slidesToScroll: 1,
      draggable: true,
      scrollLock: true,
      scrollLockDelay: 0,
      rewind: false,
      arrows: {
        prev: '.calendar-slider-prev',
        next: '.calendar-slider-next',
      },
      responsive: [
        {
          // screens greater than >= 768px
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          // screens greater than >= 1200px
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
          },
        },
      ],
    });
    //gliderAutoplay(slider, { interval: 6000 });
  }

  // faq
  if (document.querySelector('.faq')) {
    faqQuestion = document.getElementsByClassName('faq__question');
    for (i = 0; i < faqQuestion.length; i++) {
      faqQuestion[i].addEventListener('click', function () {
        if (this.closest('.faq__item').classList.contains('is-open')) {
          this.closest('.faq__item').classList.remove('is-open');
        } else {
          this.closest('.faq__item').classList.add('is-open');
        }
      });
    }
  }

  // galerie
  if (document.querySelector('.gallery')) {
    // galerie SimpleLightBox
    document.querySelectorAll('.gallery__wrap').forEach(function (galleryLightbox) {
      // Funkce pro vytvoření a inicializaci lightboxu
      function createLightbox() {
        // Vytvoření instance lightboxu
        let lightbox = new SimpleLightbox(galleryLightbox.querySelectorAll('a'), {
          showCounter: true,
          loop: false,
          additionalHtml:
            '<div class="sl-zoom-controls"><button class="sl-zoom sl-zoom-out"><span class="icon icon--icon-zoom-out"><svg class="icon__svg" viewBox="0 0 24 24" width="24" height="24" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd"><path d="M15.853 16.56c-1.683 1.517-3.911 2.44-6.353 2.44-5.243 0-9.5-4.257-9.5-9.5s4.257-9.5 9.5-9.5 9.5 4.257 9.5 9.5c0 2.442-.923 4.67-2.44 6.353l7.44 7.44-.707.707-7.44-7.44zm-6.353-15.56c4.691 0 8.5 3.809 8.5 8.5s-3.809 8.5-8.5 8.5-8.5-3.809-8.5-8.5 3.809-8.5 8.5-8.5zm-4.5 8h9v1h-9v-1z"></path></svg></span></button><button class="sl-zoom sl-zoom-in"><span class="icon icon--icon-zoom-in"><svg class="icon__svg" viewBox="0 0 24 24" width="24" height="24" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd"><path d="M15.853 16.56c-1.683 1.517-3.911 2.44-6.353 2.44-5.243 0-9.5-4.257-9.5-9.5s4.257-9.5 9.5-9.5 9.5 4.257 9.5 9.5c0 2.442-.923 4.67-2.44 6.353l7.44 7.44-.707.707-7.44-7.44zm-6.353-15.56c4.691 0 8.5 3.809 8.5 8.5s-3.809 8.5-8.5 8.5-8.5-3.809-8.5-8.5 3.809-8.5 8.5-8.5zm-4.5 8h4v-4h1v4h4v1h-4v4h-1v-4h-4v-1z"></path></svg></span></button></div>',
        });

        // Globální proměnná pro zoom level
        let zoomLevel = 1;
        const zoomStep = 0.2;

        // Funkce pro resetování zoomu
        function resetZoom() {
          zoomLevel = 1;
          const image = document.querySelector('.sl-wrapper .sl-image img');
          if (image) {
            image.style.scale = zoomLevel;
          }
        }

        // Přidání event listenerů při zobrazení lightboxu
        lightbox.on('shown.simplelightbox', function () {
          // Resetujeme zoom při každém otevření lightboxu
          resetZoom();

          // Použití querySelector na aktuální wrapper lightboxu
          const wrapper = document.querySelector('.sl-wrapper');
          if (!wrapper) return;

          const zoomInBtn = wrapper.querySelector('.sl-zoom-in');
          const zoomOutBtn = wrapper.querySelector('.sl-zoom-out');

          // Odstranění starých event listenerů pomocí klonování
          if (zoomInBtn) {
            const newZoomIn = zoomInBtn.cloneNode(true);
            zoomInBtn.parentNode.replaceChild(newZoomIn, zoomInBtn);

            newZoomIn.addEventListener('click', function (e) {
              e.stopPropagation();
              zoomLevel += zoomStep;
              const image = wrapper.querySelector('.sl-image img');
              if (image) {
                image.style.scale = zoomLevel;
              }
            });
          }

          if (zoomOutBtn) {
            const newZoomOut = zoomOutBtn.cloneNode(true);
            zoomOutBtn.parentNode.replaceChild(newZoomOut, zoomOutBtn);

            newZoomOut.addEventListener('click', function (e) {
              e.stopPropagation();
              zoomLevel = Math.max(1, zoomLevel - zoomStep);
              const image = wrapper.querySelector('.sl-image img');
              if (image) {
                image.style.scale = zoomLevel;
              }
            });
          }
        });

        // Resetování zoomu při změně obrázku
        lightbox.on('changed.simplelightbox', function () {
          resetZoom();
        });

        // Zničení a reinicializace lightboxu po zavření
        lightbox.on('closed.simplelightbox', function () {
          // Zničíme instanci lightboxu
          lightbox.destroy();

          // Vytvoříme novou instanci lightboxu
          setTimeout(function () {
            createLightbox();
          }, 100);
        });

        return lightbox;
      }

      // Inicializace lightboxu při načtení stránky
      createLightbox();
    });

    // galerie slider (Glider.js)
    document.querySelectorAll('.gallery--lightbox-view').forEach(function (slider, index) {
      if (slider.querySelector('.gallery__slider')) {
        const gallerySlider = slider.querySelector('.gallery__slider');
        const galleryImages = Array.from(slider.querySelectorAll('.gallery__image'));
        const gallerySliderItems = Array.from(slider.querySelectorAll('.gallery__slider-item'));

        let activeIndex = 0;

        const prevButton = slider.querySelector('.gallery__prev');
        const nextButton = slider.querySelector('.gallery__next');

        const glider = new Glider(gallerySlider, {
          slidesToShow: 4,
          slidesToScroll: 1,
          draggable: true,
          arrows: {
            prev: prevButton,
            next: nextButton,
          },
          responsive: [
            {
              // screens greater than >= 575px
              breakpoint: 575,
              settings: {
                slidesToShow: 'auto',
                slidesToScroll: 'auto',
                itemWidth: 80,
              },
            },
            {
              // screens greater than >= 1024px
              breakpoint: 1024,
              settings: {
                slidesToShow: 'auto',
                slidesToScroll: 'auto',
                itemWidth: 100,
              },
            },
          ],
        });

        // Update the visibility of the images based on the current active index
        function updateGalleryImages() {
          galleryImages.forEach((img, imgIndex) => {
            if (imgIndex === activeIndex) {
              img.classList.remove('is-hidden');
            } else {
              img.classList.add('is-hidden');
            }
          });
        }

        // Update the state of the prev and next buttons
        function updateButtons() {
          if (activeIndex === 0) {
            prevButton.classList.add('disabled-noclick');
          } else {
            prevButton.classList.remove('disabled-noclick');
          }

          if (activeIndex === gallerySliderItems.length - 1) {
            nextButton.classList.add('disabled-noclick');
          } else {
            nextButton.classList.remove('disabled-noclick');
          }
        }

        // Set the initial active image and button states
        updateGalleryImages();
        updateButtons();

        // Update the 'is-active' class and gallery images when a slider item is clicked
        gallerySliderItems.forEach((element, idx) => {
          element.addEventListener('click', function (event) {
            event.preventDefault();

            // Update the active index
            activeIndex = idx;

            // Add 'is-active' class to the clicked slider item and remove it from others
            gallerySliderItems.forEach((item) => item.classList.remove('is-active'));
            this.classList.add('is-active');

            // Update the gallery images and button states
            updateGalleryImages();
            updateButtons();
          });
        });

        // Add event listeners for 'prev' and 'next' buttons
        prevButton.addEventListener('click', function () {
          if (activeIndex > 0) {
            activeIndex--;
            updateGalleryImages();
            updateButtons();
            gallerySliderItems.forEach((item) => item.classList.remove('is-active'));
            gallerySliderItems[activeIndex].classList.add('is-active');
          }
        });

        nextButton.addEventListener('click', function () {
          if (activeIndex < gallerySliderItems.length - 1) {
            activeIndex++;
            updateGalleryImages();
            updateButtons();
            gallerySliderItems.forEach((item) => item.classList.remove('is-active'));
            gallerySliderItems[activeIndex].classList.add('is-active');
          }
        });
      }
    });
  }

  // gallery simple
  if (document.querySelector('.gallery-simple')) {
    // Jednoduchá galerie
    document.querySelectorAll('.gallery-simple').forEach(function (galleryLightbox) {
      // Funkce pro vytvoření a inicializaci lightboxu
      function createLightbox() {
        // Vytvoření instance lightboxu
        let lightbox = new SimpleLightbox(galleryLightbox.querySelectorAll('a'), {
          showCounter: false,
          loop: true,
          additionalHtml:
            '<div class="sl-zoom-controls"><button class="sl-zoom sl-zoom-out"><span class="icon icon--icon-zoom-out"><svg class="icon__svg" viewBox="0 0 24 24" width="24" height="24" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd"><path d="M15.853 16.56c-1.683 1.517-3.911 2.44-6.353 2.44-5.243 0-9.5-4.257-9.5-9.5s4.257-9.5 9.5-9.5 9.5 4.257 9.5 9.5c0 2.442-.923 4.67-2.44 6.353l7.44 7.44-.707.707-7.44-7.44zm-6.353-15.56c4.691 0 8.5 3.809 8.5 8.5s-3.809 8.5-8.5 8.5-8.5-3.809-8.5-8.5 3.809-8.5 8.5-8.5zm-4.5 8h9v1h-9v-1z"></path></svg></span></button><button class="sl-zoom sl-zoom-in"><span class="icon icon--icon-zoom-in"><svg class="icon__svg" viewBox="0 0 24 24" width="24" height="24" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd"><path d="M15.853 16.56c-1.683 1.517-3.911 2.44-6.353 2.44-5.243 0-9.5-4.257-9.5-9.5s4.257-9.5 9.5-9.5 9.5 4.257 9.5 9.5c0 2.442-.923 4.67-2.44 6.353l7.44 7.44-.707.707-7.44-7.44zm-6.353-15.56c4.691 0 8.5 3.809 8.5 8.5s-3.809 8.5-8.5 8.5-8.5-3.809-8.5-8.5 3.809-8.5 8.5-8.5zm-4.5 8h4v-4h1v4h4v1h-4v4h-1v-4h-4v-1z"></path></svg></span></button></div>',
        });

        // Globální proměnná pro zoom level
        let zoomLevel = 1;
        const zoomStep = 0.2;

        // Funkce pro resetování zoomu
        function resetZoom() {
          zoomLevel = 1;
          const image = document.querySelector('.sl-wrapper .sl-image img');
          if (image) {
            image.style.scale = zoomLevel;
          }
        }

        // Přidání event listenerů při zobrazení lightboxu
        lightbox.on('shown.simplelightbox', function () {
          // Resetujeme zoom při každém otevření lightboxu
          resetZoom();

          // Použití querySelector na aktuální wrapper lightboxu
          const wrapper = document.querySelector('.sl-wrapper');
          if (!wrapper) return;

          const zoomInBtn = wrapper.querySelector('.sl-zoom-in');
          const zoomOutBtn = wrapper.querySelector('.sl-zoom-out');

          // Odstranění starých event listenerů pomocí klonování
          if (zoomInBtn) {
            const newZoomIn = zoomInBtn.cloneNode(true);
            zoomInBtn.parentNode.replaceChild(newZoomIn, zoomInBtn);

            newZoomIn.addEventListener('click', function (e) {
              e.stopPropagation();
              zoomLevel += zoomStep;
              const image = wrapper.querySelector('.sl-image img');
              if (image) {
                image.style.scale = zoomLevel;
              }
            });
          }

          if (zoomOutBtn) {
            const newZoomOut = zoomOutBtn.cloneNode(true);
            zoomOutBtn.parentNode.replaceChild(newZoomOut, zoomOutBtn);

            newZoomOut.addEventListener('click', function (e) {
              e.stopPropagation();
              zoomLevel = Math.max(1, zoomLevel - zoomStep);
              const image = wrapper.querySelector('.sl-image img');
              if (image) {
                image.style.scale = zoomLevel;
              }
            });
          }
        });

        // Resetování zoomu při změně obrázku
        lightbox.on('changed.simplelightbox', function () {
          resetZoom();
        });

        // Zničení a reinicializace lightboxu po zavření
        lightbox.on('closed.simplelightbox', function () {
          // Zničíme instanci lightboxu
          lightbox.destroy();

          // Vytvoříme novou instanci lightboxu
          setTimeout(function () {
            createLightbox();
          }, 100);
        });

        return lightbox;
      }

      // Inicializace lightboxu při načtení stránky
      createLightbox();
    });
  }

  // intro pano
  if (document.querySelector('.intro__pano') && document.getElementById('pano')) {
    pano();
  }

  // slider
  if (document.querySelector('.intro__carousel')) {
    const slider = new Glider(document.querySelector('.intro__carousel'), {
      slidesToShow: 1,
      slidesToScroll: 1,
      scrollLock: true,
      dots: '.intro__dots',
      rewind: true,
    });
    gliderAutoplay(slider, { interval: 6000 });
  }

  if (document.querySelector('.events-page')) {
    bindCalendarEventDayClick();
    bindSearchEventsListener();
    bindEventCategoryChange();
  }

  if (document.querySelector('.global-search-page')) {
    bindTabs();
  }
  // if (document.querySelector('.news-page') || document.querySelector('.office-boards-page')  || document.querySelector('.global-search-page')) {
  //
  //   // bindSearchButtons();
  //   // bindSearchInputs();
  // }
  bindSearchSelects();
  bindSearchButtons();
  bindSearchInputs();

  // if (document.querySelector('.news-page')) {
  //   bindSearchNewsListener();
  // }

  function getContentWidth(element) {
    let widthWithPaddings = element.clientWidth;
    const elementComputedStyle = window.getComputedStyle(element, null);
    return widthWithPaddings - parseFloat(elementComputedStyle.paddingLeft) - parseFloat(elementComputedStyle.paddingRight);
  }

  // template 2 footer hero city name font size adjustment
  if (document.querySelector('#footer-hero-name')) {
    const container = document.querySelector('.footer__content');
    if (container) {
      function resizeTextToFit(element) {
        let parentWidth = getContentWidth(container);
        let fontSize = 200; // Start with a large size
        element.style.fontSize = fontSize + 'px';
        while (element.scrollWidth > parentWidth && fontSize > 10) {
          fontSize--;
          element.style.fontSize = fontSize + 'px';
        }
      }
      window.onload = () => {
        resizeTextToFit(document.querySelector('#footer-hero-name'));
      };
      window.onresize = () => {
        resizeTextToFit(document.querySelector('#footer-hero-name'));
      };
    }
  }

  function bindSearchSelects() {
    document.querySelectorAll('form .custom-select').forEach((selectContainer) => {
      const form = selectContainer.closest('form');
      if (!form) return;

      const select = selectContainer.querySelector('select');

      if (form && form.hasAttribute('data-budget-form')) {
        select.addEventListener('change', function () {
          form.submit();
        });
        return;
      }

      const container = selectContainer.closest('.content-grid');
      let loading = container ? container.querySelector('.spinner__wrap') : null;

      select.addEventListener('change', function () {
        fetchSearch(form, 1, loading);
      });
    });
  }

  function bindSearchButtons() {
    const buttons = document.querySelectorAll('[data-id="search-btn"]');

    if (document.querySelector('.global-search-page')) {
      const pageForm = document.querySelector('.global-search-page form[name="global_search_form"]');
      if (pageForm) {
        const container = pageForm.closest('.content-grid');
        const loading = container ? container.querySelector('.spinner__wrap') : null;

        pageForm.addEventListener('submit', function (e) {
          console.log('FORM SUBMIT triggered on page form');
          e.preventDefault();

          const activeTab = document.querySelector('.js-tab-open.is-active');
          let activeType = null;
          if (activeTab) {
            const href = activeTab.getAttribute('href');
            activeType = href.replace('#tab-', '');
            console.log('SUBMIT - active type:', activeType);
          } else {
            console.log('SUBMIT - No active tab found, using default');
            activeType = 'pages';
          }
          fetchGlobalSearch(pageForm, loading, 1, activeType);
        });
      }
    }

    buttons.forEach((btn) => {
      const container = btn.closest('.content-grid');
      const loading = container ? container.querySelector('.spinner__wrap') : null;
      const form = btn.closest('form');

      console.log('Button found, form:', form ? form.name : 'no form', 'dataset.type:', form ? form.dataset.type : 'n/a');

      if (!form) return;

      // Bind pagination
      if (form.name === 'global_search_form' && form.dataset.type !== 'header-search') {
        bindPaginationGlobalSearch(form, loading);
      } else {
        bindPagination(form, loading);
      }

      // Button click handler
      btn.addEventListener('click', function (e) {
        console.log('BUTTON CLICKED!', 'form.name:', form.name, 'form.dataset.type:', form.dataset.type);
        e.preventDefault();

        if (form.name === 'global_search_form' && form.dataset.type === 'page-search') {
          console.log('Global search page button clicked');
          // Zjistit aktivní tab a resultsInfo
          const activeTab = document.querySelector('.js-tab-open.is-active');
          const resultsInfo = document.querySelectorAll('.results-info');
          let activeType = null;
          if (activeTab) {
            const href = activeTab.getAttribute('href');
            activeType = href.replace('#tab-', '');
            console.log('BUTTON CLICK - active type:', activeType);
          } else {
            console.log('BUTTON CLICK - No active tab found, using default');
            activeType = 'pages';
          }
          fetchGlobalSearch(form, loading, 1, activeType, resultsInfo);
        } else if (form.name === 'global_search_form') {
          console.log('Header search - submitting form normally');
          form.submit();
        } else {
          console.log('Other form, calling fetchSearch');
          fetchSearch(form, 1, loading);
        }
      });
    });
  }

  function fetchSearch(form, page, loading) {
    fetchAndUpdate(form, undefined, page, loading, true);
  }

  function fetchGlobalSearch(form, loading, page = null, type = null, resultsInfo = null) {
    fetchAndUpdateGlobalSearch(form, undefined, loading, page, type, resultsInfo);
  }

  function fetchAndUpdateGlobalSearch(form, token, loading, page, type, resultsInfo) {
    if (form.dataset.type !== 'header-search' && loading) loading.classList.remove('is-hidden');

    // Schovej resultsInfo při načítání (získej přímo, pokud není předáno)
    const resultsInfoElements = resultsInfo || document.querySelectorAll('.results-info');
    if (resultsInfoElements && resultsInfoElements.length > 0) {
      resultsInfoElements.forEach((info) => {
        info.classList.add('is-hidden');
      });
    }

    const formData = new FormData(form);
    const paramsObj = Object.fromEntries(formData.entries());

    if (page) paramsObj.page = page;
    if (type) paramsObj.type = type;

    const params = new URLSearchParams(paramsObj);
    const newUrl = `${window.location.pathname}?${params.toString()}`;

    history.pushState({}, '', newUrl);

    fetchAction(form, token, null, true)
      .then((result) => {
        if (loading) loading.classList.add('is-hidden');

        if (!result.success) showToast(result.message, 'error');

        if (form.dataset.type === 'header-search') {
          form.submit();
        } else {
          for (const tabName in result.filter.totalItems) {
            const counterElement = document.querySelector(`#tab-${tabName}-counter`);
            const tabLabel = `${counterElement.dataset.label} (${result.filter.totalItems[tabName]})`;
            counterElement.textContent = tabLabel;
            counterElement.parentElement.dataset.total_items = result.filter.totalItems[tabName];
            counterElement.parentElement.dataset.text = tabLabel;
          }

          const totalItemsElement = document.querySelector('#search-total-items');
          totalItemsElement.textContent = result.filter.totalFoundItems;

          for (const key in result.tabs) {
            const tabContainer = document.querySelector(`#tab-${key}`);
            tabContainer.innerHTML = result.tabs[key];

            // Pokud tab není aktivní, skrýt resultsInfo (zobrazí se jen když uživatel na něj klikne)
            if (!tabContainer.classList.contains('is-open')) {
              const resultsInfoInTab = tabContainer.querySelector('.results-info');
              if (resultsInfoInTab) {
                resultsInfoInTab.classList.add('is-hidden');
              }
            }

            bindPaginationGlobalSearch(form, loading, tabContainer, key);
          }
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
      })
      .catch((error) => {
        if (loading) loading.classList.add('is-hidden');
        console.error(error);
        showToast(error.message, 'error');
      });
  }

  function bindPaginationGlobalSearch(form, loading, container = null, type = null) {
    if (!container) {
      const containers = document.querySelectorAll('[data-type="tab-content-global-search"]');

      if (containers.length > 0) {
        containers.forEach((container) => {
          bindLinks(container);
        });
      }
    }

    if (container) {
      bindLinks(container);
    }

    function bindLinks(container) {
      container.querySelectorAll('#pagination-item, #pagination-next, #pagination-prev').forEach((link) => {
        link.removeEventListener('click', handlePaginationClick);
        link.addEventListener('click', handlePaginationClick);
      });
    }
    function handlePaginationClick(event) {
      event.preventDefault();

      const url = new URL(this.href);
      const page = url.searchParams.get('page') || 1;
      const searchType = url.searchParams.get('type') || type || null;

      fetchGlobalSearch(form, loading, parseInt(page), searchType);
    }
  }

  function bindPagination(form, loading) {
    form.querySelectorAll('#pagination-item, #pagination-next, #pagination-prev').forEach((link) => {
      link.removeEventListener('click', handlePaginationClick);
      link.addEventListener('click', handlePaginationClick);
    });

    function handlePaginationClick(event) {
      event.preventDefault();
      const url = new URL(this.href);
      const page = url.searchParams.get('page') || 1;
      fetchSearch(this.closest('form'), parseInt(page), loading);
    }
  }

  function fetchAndUpdate(form, token, page, loading = null, disableCaptcha = false) {
    const formData = new FormData(form);
    const paramsObj = Object.fromEntries(formData.entries());

    paramsObj.page = page;

    if (!disableCaptcha) {
      delete paramsObj[`${form.name}[captcha]`];
    }

    const params = new URLSearchParams(paramsObj);
    const newUrl = `${window.location.pathname}?${params.toString()}`;

    history.pushState({}, '', newUrl);

    if (loading) loading.classList.remove('is-hidden');

    fetchAction(form, token, page, disableCaptcha)
      .then((result) => {
        if (loading) loading.classList.add('is-hidden');
        document.getElementById(`${form.name}_results`).innerHTML = result.html || '';
        document.getElementById(`${form.name}_pagination`).innerHTML = result.htmlPagination || '';

        const resultsCountElement = document.querySelector('.filtering p');
        if (resultsCountElement && result.resultsCountText) {
          // Use localized text from backend instead of hardcoded pluralization
          resultsCountElement.textContent = result.resultsCountText;
        }

        window.scrollTo({ top: 0, behavior: 'smooth' });

        let newLoading = form.closest('.content-grid').querySelector('.spinner__wrap');
        bindPagination(form, newLoading);
        share();
      })
      .catch((error) => {
        if (loading) loading.classList.add('is-hidden');
        console.error(error);
        showToast(error.message, 'error');
      });
  }

  function bindSearchInputs() {
    document.querySelectorAll('[data-id="search-input"]').forEach((el) => {
      const container = el.closest('.content-grid');
      const loading = container ? container.querySelector('.spinner__wrap') : null;
      const form = el.closest('form');

      if (!form) return;

      el.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.keyCode === 13) {
          e.preventDefault();
          console.log('ENTER pressed in search input, form:', form.name, 'dataset.type:', form.dataset.type);

          if (form.name === 'global_search_form' && form.dataset.type === 'page-search') {
            // Global search page - zjistit aktivní tab a resultsInfo
            const activeTab = document.querySelector('.js-tab-open.is-active');
            const resultsInfo = document.querySelectorAll('.results-info');
            let activeType = null;
            if (activeTab) {
              const href = activeTab.getAttribute('href');
              activeType = href.replace('#tab-', '');
              console.log('ENTER - active type:', activeType);
            } else {
              console.log('ENTER - No active tab found, using default');
              activeType = 'pages';
            }
            fetchGlobalSearch(form, loading, 1, activeType, resultsInfo);
          } else if (form.name === 'global_search_form') {
            // Header search - bez type parametru
            fetchGlobalSearch(form, loading);
          } else {
            fetchSearch(form, 1, loading);
          }
        }
      });
    });
  }

  function removeQueryParams(paramsToRemove) {
    const url = new URL(window.location.href);
    paramsToRemove.forEach((param) => url.searchParams.delete(param));

    // Перезаписуємо URL без перезавантаження сторінки
    window.history.replaceState({}, '', url.toString());
  }

  function bindTabs() {
    const form = document.querySelector('.global-search-page form[name="global_search_form"]');
    const loading = document.querySelector('.global-search-page .spinner__wrap');

    console.log('bindTabs - form found:', form);
    console.log('bindTabs - form dataset.type:', form ? form.dataset.type : 'no form');

    document.querySelectorAll('.js-tab-open').forEach((tab) => {
      tab.addEventListener('click', function (e) {
        console.log('Tab clicked:', this.getAttribute('href'));

        if (form && form.dataset.type === 'page-search') {
          console.log('Sending AJAX request for tab');
          e.preventDefault();

          const href = this.getAttribute('href');
          const type = href.replace('#tab-', '');

          console.log('Extracted type:', type);

          // Získat resultsInfo dynamicky při každém kliku
          const resultsInfo = document.querySelectorAll('.results-info');

          // Okamžitě skrýt všechny resultsInfo před AJAX requestem
          resultsInfo.forEach((info) => {
            info.classList.add('is-hidden');
          });

          fetchGlobalSearch(form, loading, 1, type, resultsInfo);
        } else {
          console.log('NOT sending AJAX - form:', form, 'dataset.type:', form ? form.dataset.type : 'no form');
        }

        localStorage.setItem('activeTab', this.getAttribute('href'));
      });
    });

    const activeTab = localStorage.getItem('activeTab');
    if (activeTab) {
      const openContent = document.querySelector('.tab-content.is-open');
      if (openContent) openContent.classList.remove('is-open');

      const targetContent = document.querySelector(activeTab);
      if (targetContent) targetContent.classList.add('is-open');

      // Also set the active class for the corresponding tab navigation link
      const activeLink = document.querySelector('.js-tab-open.is-active');
      if (activeLink) activeLink.classList.remove('is-active');

      const tab = document.querySelector(`[href="${activeTab}"]`);
      if (tab) tab.classList.add('is-active');

      // Fetch data for the restored tab if it's not the default tab
      if (form && form.dataset.type === 'page-search' && activeTab !== '#tab-stranky') {
        const type = activeTab.replace('#tab-', '');
        const resultsInfo = document.querySelectorAll('.results-info');

        // Hide resultsInfo immediately
        resultsInfo.forEach((info) => {
          info.classList.add('is-hidden');
        });

        fetchGlobalSearch(form, loading, 1, type, resultsInfo);
      }
    }
  }
});

function initAccessibilityTranslations() {
  const translations = {
    // Buttons
    'Reset All': 'Resetovat vše',
    'Switch Sides': 'Přepnout strany',

    // Section Headings
    'Content Adjustments': 'Úpravy obsahu',
    'Color Adjustments': 'Úpravy barev',
    'Orientation Adjustments': 'Úpravy orientace',

    // Content Adjustments
    'Font Scaling': 'Změna velikosti písma',
    'Highlight Links': 'Zvýraznit odkazy',
    'Readable Font': 'Čitelný font',
    'Remove Link Highlights': 'Odstranit zvýraznění odkazů',

    // Color Adjustments
    Grayscale: 'Odstíny šedi',
    'High Contrast': 'Vysoký kontrast',
    'Negative Contrast': 'Invertovaný kontrast',
    'Light Contrast': 'Světlý kontrast',
    'Dark Contrast': 'Tmavý kontrast',
    'Remove High Contrast': 'Odstranit vysoký kontrast',
    'Remove Light Contrast': 'Odstranit světlý kontrast',
    'Remove Dark Contrast': 'Odstranit tmavý kontrast',

    // Orientation Adjustments
    'Mute Sounds': 'Vypnout zvuky',
    'Hide Images': 'Skrýt obrázky',
    'Big Cursor': 'Velký kurzor',
    'Resume Sounds': 'Obnovit zvuky',
    'Show Images': 'Zobrazit obrázky',
    'Stop Big Cursor': 'Zrušit velký kurzor',

    // Branding
    'Accessibility Options': 'Možnosti přístupnosti',
    'MAX ACCESS': 'MAX ACCESS',

    // Mobile-specific (tooltip translations)
    'Font Scaling ( Large )': 'Změna velikosti písma (Velké)',
    'Font Scaling ( Extra Large )': 'Změna velikosti písma (Extra velké)',
    'Font Scaling ( Default )': 'Změna velikosti písma (Výchozí)',
    'Change Contrast ( Black on White )': 'Změnit kontrast (Černé na bílé)',
    'Change Contrast ( White on Black )': 'Změnit kontrast (Bílé na černé)',
    'Change Contrast ( Default )': 'Změnit kontrast (Výchozí)',
    'Readable Font ( OpenDyslexic )': 'Čitelný font (OpenDyslexic)',
    'Readable Font ( PT Sans )': 'Čitelný font (PT Sans)',
    'Readable Font ( PT Serif )': 'Čitelný font (PT Serif)',
    'Readable Font ( Default )': 'Čitelný font (Výchozí)',
  };

  function translateToolbar() {
    const toolbar = document.querySelector('#oada-accessibility-toolbar');
    if (!toolbar) return;

    toolbar.querySelectorAll('*').forEach((el) => {
      el.childNodes.forEach((node) => {
        if (node.nodeType === 3) {
          const trimmedText = node.nodeValue.trim();
          if (translations[trimmedText]) {
            node.nodeValue = translations[trimmedText];
          }
        }
      });

      if (el.title && translations[el.title]) {
        el.title = translations[el.title];
      }
    });
  }

  function translateTooltips() {
    document.querySelectorAll('div.oadatb-tooltip-box.ada-ignore-all').forEach((tooltip) => {
      tooltip.childNodes.forEach((node) => {
        if (node.nodeType === 3) {
          const trimmedText = node.nodeValue.trim();
          if (translations[trimmedText]) {
            node.nodeValue = translations[trimmedText];
          }
        }
      });

      if (tooltip.title && translations[tooltip.title]) {
        tooltip.title = translations[tooltip.title];
      }
    });
  }

  const checkInterval = setInterval(() => {
    const toolbar = document.querySelector('#oada-accessibility-toolbar');
    if (toolbar) {
      clearInterval(checkInterval);
      translateToolbar();
    }
  }, 300);

  document.addEventListener('click', function (event) {
    if (event.target.closest('#oada-accessibility-toolbar')) {
      setTimeout(() => {
        translateToolbar();
        translateTooltips();
      }, 100);
    }
  });

  const observer = new MutationObserver(() => {
    translateToolbar();
    translateTooltips();
  });

  setInterval(() => {
    const toolbar = document.querySelector('#oada-accessibility-toolbar');
    if (toolbar) {
      observer.observe(toolbar, { subtree: true, characterData: true, attributes: true });
    }
  }, 1000);
}

// Function to handle the back to top button
document.addEventListener('DOMContentLoaded', function () {
  let backToTopButton = document.getElementById('backToTop');

  // Show the button when user scrolls down 300px from the top
  window.onscroll = function () {
    if (document.body.scrollTop > 300 || document.documentElement.scrollTop > 300) {
      backToTopButton.style.display = 'block';
    } else {
      backToTopButton.style.display = 'none';
    }
  };

  backToTopButton.addEventListener('click', function () {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
});

// Newsletter form
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('input[name="formType"][value="newsletter"]').forEach(function (hiddenInput) {
    var form = hiddenInput.closest('form');
    if (!form) return;

    var smsCheckbox = form.querySelector('[name$="[sendSms]"]');
    var phoneContainer = form.querySelector('[id*="phone-field-container"]');
    var phoneField = form.querySelector('[name$="[phone]"]');
    var emailCheckbox = form.querySelector('[name$="[sendEmail]"]');
    var emailField = form.querySelector('[name$="[email]"]');
    var emailFieldContainer = form.querySelector('[id*="email-field-container"]');

    if (smsCheckbox && phoneContainer && phoneField) {
      var togglePhoneField = function () {
        if (smsCheckbox.checked) {
          phoneContainer.style.display = 'block';
          phoneField.setAttribute('required', 'required');
          phoneField.setAttribute('aria-required', 'true');
        } else {
          phoneContainer.style.display = 'none';
          phoneField.removeAttribute('required');
          phoneField.setAttribute('aria-required', 'false');
          phoneField.value = '';
        }
      };

      togglePhoneField();
      smsCheckbox.addEventListener('change', togglePhoneField);
    }

    if (emailCheckbox && emailField && emailFieldContainer) {
      var toggleEmailField = function () {
        if (emailCheckbox.checked) {
          emailFieldContainer.style.display = 'block';
          emailField.setAttribute('required', 'required');
          emailField.setAttribute('aria-required', 'true');
        } else {
          emailFieldContainer.style.display = 'none';
          emailField.removeAttribute('required');
          emailField.setAttribute('aria-required', 'false');
          emailField.value = '';
        }
      };

      toggleEmailField();
      emailCheckbox.addEventListener('change', toggleEmailField);
    }
  });
});

function initFacebookWidget(widgetId) {
  const widgetElement = document.getElementById(widgetId);
  if (!widgetElement) return;

  const fbPageElement = widgetElement.querySelector('.fb-page');
  if (fbPageElement) {
    const currentWidth = Math.min(window.innerWidth - 40, 1500);
    fbPageElement.setAttribute('data-width', currentWidth);
  }

  if (typeof window.FB !== 'undefined') {
    if (window.FB.XFBML) {
      window.FB.XFBML.parse(widgetElement);
    }
    return;
  }

  if (!document.querySelector('script[src*="connect.facebook.net"]')) {
    const script = document.createElement('script');
    script.async = true;
    script.defer = true;
    script.crossOrigin = 'anonymous';
    script.src = 'https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v19.0';
    script.nonce = 'fb-' + Math.random().toString(36).substr(2, 9);

    script.onload = function () {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
          if (window.FB && window.FB.XFBML) {
            window.FB.XFBML.parse(widgetElement);
          }
        });
      } else {
        if (window.FB && window.FB.XFBML) {
          window.FB.XFBML.parse(widgetElement);
        }
      }
    };

    script.onerror = function () {
      console.warn('Facebook SDK failed to load');
    };

    document.head.appendChild(script);
  } else {
    const checkFB = setInterval(function () {
      if (window.FB && window.FB.XFBML) {
        clearInterval(checkFB);
        window.FB.XFBML.parse(widgetElement);
      }
    }, 100);

    setTimeout(function () {
      clearInterval(checkFB);
    }, 10000);
  }
}

function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

let previousWindowWidth = window.innerWidth;

function refreshFacebookWidgets() {
  const currentWidth = window.innerWidth;

  const shouldUpdate = (previousWindowWidth < 580 && currentWidth >= 580) || (previousWindowWidth >= 580 && currentWidth < 580);

  if (shouldUpdate) {
    const facebookWidgets = document.querySelectorAll('.fb-page-embed-wrap');
    facebookWidgets.forEach(function (widget) {
      const fbPageElement = widget.querySelector('.fb-page');
      if (fbPageElement) {
        const newWidth = Math.min(currentWidth - 40, 1500);
        fbPageElement.setAttribute('data-width', newWidth);

        if (window.FB && window.FB.XFBML) {
          window.FB.XFBML.parse(widget);
        }
      }
    });
  }

  previousWindowWidth = currentWidth;
}

const initMaxAccess = (timeout = 0) => {
  setTimeout(() => {
    var lazyScript = document.getElementById('oada_ma_toolbar_script');
    if (lazyScript) {
      var newScript = document.createElement('script');
      newScript.type = 'text/javascript';
      newScript.text = lazyScript.innerHTML;
      document.body.appendChild(newScript);
    }
  }, timeout);
};

document.addEventListener('DOMContentLoaded', function () {
  const facebookWidgets = document.querySelectorAll('.fb-page-embed-wrap');
  if (facebookWidgets.length > 0) {
    facebookWidgets.forEach(function (widget) {
      if (widget.id) {
        initFacebookWidget(widget.id);
      }
    });
    initMaxAccess(1000);
  } else {
    initMaxAccess();
  }
  const debouncedResize = debounce(refreshFacebookWidgets, 250);
  window.addEventListener('resize', debouncedResize);
});
